var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":""}},[_c('h2',{staticClass:"font--white ma-auto"},[_vm._v(" Hang on we are signing you out! "),_c('v-progress-circular',{attrs:{"indeterminate":"","color":"white"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }